/** Tải một tệp tĩnh cùng nguồn gốc bằng liên kết ẩn, để trình duyệt tự lưu thay vì mở. */
export function taiTepTinh(duongDan: string, tenTep: string): void {
  const a = document.createElement('a');
  a.href = duongDan;
  a.download = tenTep;
  a.rel = 'noopener';
  document.body.append(a);
  a.click();
  a.remove();
}
